import React, { ReactElement } from 'react';
import { Icon } from 'semantic-ui-react';
import { SemanticShorthandContent } from 'semantic-ui-react/dist/commonjs/generic';

export type DropdownValue = boolean | number | string | (boolean | number | string)[];

export interface DropdownOption {
  key: string | number;
  text: string | number;
  value: any;
  content?: SemanticShorthandContent;
  inactive?: boolean;
  icon?: ReactElement;
  disabled?: boolean;
  predefinedOption?: boolean;
}

export const mapToDropdownOptionArray = (
    list: Array<any>,
    textKey: string | Array<number | string>,
    key?: string | number,
    value?: string | number): Array<DropdownOption> => {

  return list.map(element => {

    const text = typeof textKey == "string" ?
        element[textKey] : textKey.map(subKey => element[subKey]).join(" ");

    return {
      key: key ? element[key] : element.id,
      text: text,
      value: value ? element[value] : element.id
    }
  });
};

export const mapToDropdownOptionArrayWithSep = (
    list: Array<any>,
    textKey: string | Array<number | string>,
    key?: string | number,
    value?: string | number,
    separator?: string): Array<DropdownOption> => {

  return list.map(element => {

    const text = typeof textKey == "string" ?
        element[textKey] : textKey.map(subKey => element[subKey]).join(separator ? separator : ", ");

    return {
      key: key ? element[key] : element.id,
      text: text,
      value: value ? element[value] : element.id
    }
  });
};

export const mapToDropdownOptionArrayWithTextGetter = (
    list: Array<any>,
    textGetter: (item: any) => string,
    key?: string | number,
    valueKey?: string | number): Array<DropdownOption> => {

  return list.map(element => {

    return {
      key: key ? element[key] : element.id,
      text: textGetter(element),
      value: valueKey ? element[valueKey] : element.id
    }
  });
};

export const mapToDropdownOptionArrayWithActive = (
    list: Array<any>,
    textKeyOrProvider: string | ((item: any) => string),
    key?: string | number,
    value?: string | number): Array<DropdownOption> => {

  return list.map(element => {

    const text = typeof textKeyOrProvider == "string" ?
        element[textKeyOrProvider] : textKeyOrProvider(element);

    const inactive = !element["active"];
    const icon = inactive ? <Icon name="ban" color="grey" className="right floated"/> : undefined;

    return {
      key: key ? element[key] : element.id,
      text: text,
      value: value ? element[value] : element.id,
      className: inactive ? "inactive" : "",
      icon: icon
    };
  });
};

export const stringArrayToDropdownOptionArray = (
    list: Array<string>,
    getMessage: Function,
    messageKey?: string,
    keyList?: Array<string | number>): Array<DropdownOption> => {

  return list.map((element, index) => {
    const keyValuePair = keyList ? keyList[index] : element.toUpperCase();
    return {
      key: keyValuePair,
      text: messageKey ? getMessage(`${messageKey}.${element}`) : `${element}`,
      value: keyValuePair
    }
  });
};
